import { useState, useContext } from 'react'
import { Helmet } from 'react-helmet'
import { AuthContext } from '../contexts/auth'


const Login = () => {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const { login, loadingAuth } = useContext(AuthContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email !== '' && password !== '') {
            login(email, password)
        }
    }

    return (
        <div className="bg-gradient-primary bg-color">
        <Helmet>
            <title>Entrar - Coluço System</title>
        </Helmet>
            <div className="container box">
                <div className="row justify-content-center align-center">
                    <div className="col-xl-6 col-lg-12 col-md-9">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                <div className="p-5">
                                    <div className="text-center">
                                        <h1 className="h4 text-gray-900 mb-4">Coluço System</h1>
                                    </div>
                                    <form className="user" onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input type="email" className="form-control form-control-user"
                                                id="exampleInputEmail" value={email} onChange={e => setEmail(e.target.value)} aria-describedby="emailHelp"
                                                placeholder="E-mail." />
                                        </div>
                                        <div className="form-group">
                                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-control form-control-user"
                                                id="exampleInputPassword" placeholder="Senha" />
                                        </div>
                                        <button className="btn btn-primary btn-user btn-block">
                                            {loadingAuth ? <i class="fas fa-spinner fa-spin"></i>
                                                :
                                                <>Entrar</>
                                            }
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login